<template>
	<div class="container">
		<div class="g-p-30">
			<el-tabs v-model="tabNow">
				<el-tab-pane label="我的简历" name="1"></el-tab-pane>
			</el-tabs>
			<!--  个人信息  -->
			<div class="g-flex g-col-top g-m-t-30">
				<div class="label g-font-16 main-text">
					个人信息
				</div>
				<div class="g-m-l-50">
					<div class="g-flex g-col-top">
						<!--  左侧列  -->
						<div>
							<div class="inputs">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">姓名</p>
								</div>
								<el-input class="inputs" readonly v-model="detail.name" placeholder="请输入"></el-input>
							</div>
							<div class="inputs g-m-t-15">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">学历</p>
								</div>
								<el-select class="inputs" disabled v-model="detail.education" placeholder="请选择">
									<el-option v-for="item in diploma_list" :key="item.dictKey" :label="item.dictValue"
										:value="item.dictKey">
									</el-option>
								</el-select>
							</div>

							<div class="inputs g-m-t-15">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">工作时长</p>
								</div>
								<el-select class="inputs" disabled v-model="detail.workYear" placeholder="请选择">
									<el-option v-for="item in work_year_list" :key="item.dictKey"
										:label="item.dictValue" :value="item.dictKey">
									</el-option>

								</el-select>
							</div>

							<div class="inputs g-m-t-15">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">求职岗位</p>
								</div>
								<el-select class="inputs" v-model="detail.postId" placeholder="请选择">
									<el-option v-for="item in postList" :key="item.id" :label="item.postName"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
							<div class="inputs g-m-t-15">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">邮箱</p>
								</div>
								<el-input class="inputs" readonly v-model="detail.email" placeholder="请输入"></el-input>
							</div>

							<div class="inputs g-m-t-15">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">电话</p>
								</div>
								<el-input class="inputs" readonly v-model="detail.phone" placeholder="请输入"></el-input>
							</div>
						</div>
						<!--  右侧列  -->
						<div class="g-m-l-80 g-p-l-20">
							<div class="inputs">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">性别</p>
								</div>
								<el-select class="inputs" disabled v-model="detail.gender" placeholder="请选择">
									<el-option v-for="item in gender_list" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>

							<div class="inputs g-m-t-15">
								<div class="g-font-14 g-flex g-col-center">
									<p class="white-text g-font-20 g-m-t-5">*</p>
									<p class="g-font-weight-400">生日</p>
								</div>
								<el-date-picker v-model="detail.birth" type="date" value-format="yyyy-MM-dd"
								 placeholder="选择日期">
								</el-date-picker>
							</div>

							<div class="inputs g-m-t-15">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">期望薪资</p>
								</div>
								<el-select class="inputs" v-model="detail.salary" placeholder="请选择">
									<el-option v-for="item in salary_list" :key="item.dictKey" :label="item.dictValue"
										:value="item.dictKey">
									</el-option>
									</el-option>
								</el-select>
							</div>

							<div class="inputs g-m-t-15">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">当前求职状态</p>
								</div>
								<el-select class="inputs" v-model="detail.workStatus" placeholder="请选择">
									<el-option v-for="item in work_status_list" :key="item.dictKey"
										:label="item.dictValue" :value="item.dictKey">
									</el-option>
								</el-select>
							</div>

							<div class="inputs g-m-t-15">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">微信号</p>
								</div>
								<el-input class="inputs" readonly v-model="detail.wechat" placeholder="请输入"></el-input>
							</div>
						</div>
					</div>
					<div class="g-m-t-15 g-full-width">
						<div class="g-font-14 g-flex g-col-center">
							<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
							<p class="g-font-weight-400">个人简介</p>
						</div>
						<el-input type="textarea" class="text-areas" v-model="detail.profile" placeholder="请输入">
						</el-input>
					</div>
				</div>
			</div>

			<!--  上传简历  -->
			<div class="g-flex g-col-top g-m-t-30">
				<div class="label g-font-16 main-text">
					上传简历
				</div>
				<div class="g-m-l-50">
					<div v-if="detail.enclosure!==''" style="display: flex;align-items: center;">
						<el-link type="primary" style="font-size:16px;margin-right:10px;" :href="detail.enclosure" target="_blank">
							<i class="el-icon-document"></i>
							简历文件
						</el-link>
						<el-button type="danger" icon="el-icon-delete" size="mini" style="padding:3px;" @click="deleteFile"></el-button>
					</div>
					<uploadBtn @uploadSuccess="uploadSuccess" @removeSuccess="removeSuccess"
						:uploadConfig="uploadConfig"></uploadBtn>
				</div>
			</div>

			<!--  最后一次工作情况  -->
			<div class="g-flex g-col-top g-m-t-30">
				<div class="label g-font-16 main-text">
					最后一次工作情况
				</div>
				<div class="g-m-l-50">
					<div class="g-flex g-col-top">
						<!--  左侧列  -->
						<div>
							<div class="inputs">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">所在城市</p>
								</div>
								<el-cascader :options="regionList" :props="props" clearable v-model="defaultCity"
									@change="cityChange"></el-cascader>
							</div>
							<div class="inputs g-m-t-15">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">任职岗位</p>
								</div>
								<el-input class="inputs" v-model="lastWork.postName" placeholder="请输入"></el-input>
							</div>
							<div class="inputs g-m-t-15">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">是否隐藏该模块</p>
								</div>
								<el-select class="inputs" v-model="lastWork.status" placeholder="请选择">
									<el-option v-for="item in hideLast" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</div>
						<!--  右侧列  -->
						<div class="g-m-l-80 g-p-l-20">
							<div class="inputs">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">公司名称（或学校名称）</p>
								</div>
								<el-input class="inputs" v-model="lastWork.name" placeholder="请输入"></el-input>
							</div>

							<div class="inputs g-m-t-15">
								<div class="g-font-14 g-flex g-col-center">
									<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
									<p class="g-font-weight-400">薪资</p>
								</div>
								<el-input class="inputs" v-model="lastWork.salary" placeholder="请输入"></el-input>
							</div>
						</div>
					</div>
					<div class="g-m-t-15 g-full-width">
						<div class="g-font-14 g-flex g-col-center">
							<p class="red-text g-font-20 g-m-r-10 g-m-t-5">*</p>
							<p class="g-font-weight-400">工作内容</p>
						</div>
						<el-input type="textarea" class="text-areas" v-model="lastWork.workContent" placeholder="请输入">
						</el-input>
					</div>
				</div>
			</div>

			<!--  资格证书  -->
			<div class="g-flex g-col-top g-m-t-30">
				<div class="label g-font-16 main-text">
					资格证书
				</div>
				<div class="g-m-l-50">
					<p class="main-text g-font-14">请选择已有的证书</p>
					<div class="g-flex g-flex-wrap">
						<div class="paper-item" :class="isSelected(item.dictValue)?'active-item':''"
							v-for="(item,index) in resumeCertificate" @click="selectItem(item.dictValue)" :key="index">
							{{item.dictValue}}
						</div>
					</div>

					<div class="g-m-t-30">
						<p class="main-text g-font-14">其他证书</p>
						<el-input type="textarea" class="text-areas g-m-t-15" v-model="otherPaper" placeholder="请输入">
						</el-input>
						<div class="submit-btn add-btn g-m-t-15" @click="addPaper">
							添加
						</div>

						<!--  添加的资格证书  -->
						<div class="g-flex g-flex-wrap">
							<div class="paper-item g-rela" v-for="(item,index) in otherPaperList" :key="index">
								{{item}}
								<div class="del-icon" @click="delPaper(index)">
									<i class="el-icon-error"></i>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!--  保存按钮  -->
			<div class="g-flex g-row-center g-m-t-40">
				<div class="submit-btn save-btn" @click="doSave">保存并发布</div>
			</div>
		</div>

		<!--  保存提示  -->
		<popup-message-box ref="popup" @submit="doSubmit">
			<p class="g-text-center g-font-20 g-m-t-10">已更新！</p>
		</popup-message-box>
	</div>
</template>

<script>
	import {
		resumelDetail,
		lastworkDetail,
		portalList,
		resumelSubmit,
		lastworkSubmit
	} from "@/api/job.js";
	import {
		regionTree,
		dictionary
	} from "@/api/api.js"
	import PopupMessageBox from "@/components/message-popup";
	import uploadBtn from "@/components/upload-btn";
	import {
		throttle
	} from "@/utils/common.js"
	export default {
		name: "my-resume",
		components: {
			PopupMessageBox,
			uploadBtn
		},
		data() {
			return {
				uploadConfig: {
					tip: '支持上传：.doc .docx .pdf .jpg .png .gif文件，仅支持上传1个文件，每个文件大小不超过5MB',
					type: 'file',
					size: 1024 * 1024 * 5,
					fileType: ["doc", "docx", "pdf", "jpg", "png", "gif"]
				},
				tabNow: '1',
				detail: {},
				lastWork: {},
				gender_list: [{
						value: '1',
						label: '男'
					},
					{
						value: '2',
						label: '女'
					},
					{
						value: '3',
						label: '未知'
					}
					//性别
				], //性别

				hideLast: [{
						value: 1,
						label: '是'
					},
					{
						value: 2,
						label: '否'
					}
				], //是否
				uploadUrl: '', //上传接口
				fileList: [], //附件
				postList: [],
				paperList: [], //已有的证书列表
				selectedList: [], //已选的证书列表
				otherPaperList: [], //其他证书列表
				otherPaper: '', //手动添加的证书
				diploma_list: [],
				salary_list: [],
				work_year_list: [],
				work_status_list: [],
				regionList: [],
				defaultCity: ['', '', ''],
				props: {
					label: 'title'
				},
				resumeCertificate: [],
				throttleFlag: true //保存节流标志
			}
		},
		created() {
			this.getResumelDetail()
			this.getLastworkDetail()
			this.getDictionary('diploma')
			this.getDictionary('salary')
			this.getDictionary('work_year')
			this.getDictionary('work_status')
			this.getPostSelect()
			this.getRegionTree()
			this.getResumeCertificate()
		},
		methods: {
			deleteFile(){
				this.detail.enclosure=''
			},
			isSelected(name) {
				for (let i in this.selectedList) {
					if (this.selectedList[i] == name) {
						return true
					}
				}
				return false
			},
			getResumeCertificate() {
				dictionary({
					code: 'resume_certificate'
				}).then(res => {
					console.log(res)
					this.resumeCertificate = res
				})
			},
			cityChange(e) {
				this.lastWork.province = e[0]
				this.lastWork.city = e[1]
				this.lastWork.county = e[2]
			},
			getRegionTree() {
				regionTree({}).then(res => {
					res.shift();
					this.regionList = res;

				})
			},
			getResumelDetail() {
				resumelDetail({}).then(res => {
					this.detail = res;
					if (this.detail.birth && this.detail.birth.indexOf('CST') > 0) { //清理错误数据
						this.detail.birth = '';
					}
					this.$store.commit('$uStore', {
						name: 'userInfo.resumeId',
						value: res.id
					})
					this.uploadConfig.fileList = [{
						name: '简历文件',
						url: res.enclosure
					}]
					this.selectedList = []
					if (!!this.detail.otherCertificate) {
						this.otherPaperList = this.detail.otherCertificate.split(',')
					}
					let certificateNames = this.detail.certificateName.split(',')
					this.selectedList = Array.from(new Set(certificateNames))
					// for(let i in certificateNames){
					// 	let obj={dictValue:certificateNames[i],dictKey:certificateNames[i]}
					// 	this.selectedList.push(obj)
					// }
					console.log(this.selectedList)
				})
			},
			getLastworkDetail() {
				lastworkDetail({}).then(res => {
					this.lastWork = res
					this.lastWork.status=this.lastWork.status==-1?0:this.lastWork.status
					this.defaultCity = [this.lastWork.province, this.lastWork.city, this.lastWork.county]
					console.log(this.defaultCity)
				})
			},
			getPostSelect() {
				portalList({}).then(res => {
					this.postList = res;
				})
			},
			getDictionary(type) {
				dictionary({
					code: type
				}).then(res => {
					this[type + '_list'] = res;
				})
			},
			uploadSuccess(e) {
				this.detail.enclosure = e;
			},
			removeSuccess(e) {
				this.detail.enclosure = ''
			},
			// 上传事件
			handleChange(file, fileList) {
				this.fileList = fileList.slice(-3);
			},
			// 选择证书
			selectItem(e) {
				// if (this.selectedList.findIndex(val => val.id === e.id) > -1) {
				// 	this.selectedList.splice(this.selectedList.findIndex(val => val.id === e.id), 1)
				// } else {
				// 	this.selectedList.push(e.dictValue)
				// }

				if (this.selectedList.indexOf(e) > -1) {
					this.selectedList.splice(this.selectedList.indexOf(e))
				} else {
					this.selectedList.push(e)
				}
				if (this.selectedList.length == 0) {
					this.selectedList = [' ']

				}
				console.log(this.selectedList)
				this.$forceUpdate()
			},
			//  添加证书
			addPaper() {
				if (!this.otherPaper) {
					return this.$message({
						message: '请输入证书名称',
						type: 'warning'
					});
				} else {
					let arrIndex = this.otherPaperList.findIndex(val => val === this.otherPaper);
					if (arrIndex > -1) {
						return this.$message({
							message: '该证书已添加',
							type: 'warning'
						});
					} else {
						this.otherPaperList.push(this.otherPaper)
						this.otherPaper = ''
					}
				}
			},
			//  删除新增的证书
			delPaper(index) {
				this.otherPaperList.splice(index, 1)
			},

			//保存
			doSave() {
				this.detail.otherCertificate = this.otherPaperList.toString();
				if (!this.detail.otherCertificate) {
					this.detail.otherCertificate = 'null'; //清空标记，详情参考http.js文件内的注释
				}
				this.detail.certificateName = this.selectedList.toString()
				this.detail.certificate = this.detail.certificateName
				let l = ['name', 'education', 'workYear', 'postId', 'email', 'phone', 'gender', 'salary', 'workStatus',
					'wechat', 'profile'
				]
				let k = ['city', 'name', 'postName', 'salary', 'workContent', 'status']
				for (let i in l) {
					if (this.detail[l[i]] === '') {
						return this.$message({
							message: '带星号的必填',
							type: 'warning'
						});
					}
				}
				for (let i in k) {
					if (this.lastWork[k[i]] === '') {
						return this.$message({
							message: '带星号的必填',
							type: 'warning'
						});
					}
				}
				for (let j in this.postList) {
					if (this.detail.postId == this.postList[j].id) {
						this.detail.postName = this.postList[j].postName
					}
				}
				if (this.throttleFlag) {
					this.throttleFlag = false;
					if(this.detail.enclosure==''){
						this.detail.enclosure='10'
					}
					resumelSubmit(this.detail).then(res => {
						lastworkSubmit(this.lastWork).then(res => {
							this.throttleFlag = true;
							this.$refs.popup.open()
							this.getResumelDetail();
						})
					})
					if(this.detail.enclosure=='10'){
						this.detail.enclosure=''
					}
				} else {
					setTimeout(() => {
						this.throttleFlag = true;
					}, 1000)
				}

			},

			// 弹窗确认回调
			doSubmit() {
				this.$refs.popup.close()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		background: #ffffff;
		border-radius: 5px;
	}

	::v-deep .el-tabs__item.is-active {
		color: #333;
		font-size: 20px;
		font-weight: 500;
	}

	::v-deep .el-input__inner {
		background: #F6F6F8;
		border-radius: 5px;
		border: none;
	}

	.inputs {
		width: 240px;
	}

	.text-areas {
		::v-deep .el-textarea__inner {
			padding: 15px;
			border: none;
			background: #F6F6F8;
			border-radius: 5px;
		}
	}

	.paper-item {
		padding: 8px 12px;
		border-radius: 5px;
		background: #e9f2ff;
		color: #407aff;
		font-size: 14px;
		margin: 15px 20px 0 0;
		cursor: pointer;

		&:hover {
			background: rgba($color: #407aff, $alpha: 0.8);
			color: #ffffff;
			transition: all ease-in 0.2s;
		}
	}

	.active-item {
		background: #407aff;
		color: #ffffff;
		transition: all ease-in 0.2s;
	}

	.add-btn {
		padding: 7px 21px;
		margin: 30px 0;
		display: inline-block;
	}

	.del-icon {
		font-size: 20px;
		position: absolute;
		right: -10px;
		top: -10px;
		color: #407aff;
		z-index: 999;
	}

	.save-btn {
		padding: 6px 15px;
	}
</style>
